import React from 'react'
import _ from 'lodash'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { Trans } from 'react-i18next'

import {
  PORTAL_IMAGE_STORE_MODAL,
  IMAGE_EDIT_MODAL,
} from '../../../constants/modalType'
import {
  SET_PROFILE_IMAGE,
  UPDATE_PROFILE_IMAGE,
  ADD_GALLERY_IMAGE,
  UPDATE_GALLERY_IMAGE,
  ADD_LINK_IMAGE,
  UPDATE_LINK_IMAGE,
} from '../../../constants/actions'
import withReduxModal from '../../../modules/redux-modal/redux/withReduxModal'

class ImageActionModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      imageFile: null,
    }
  }

  componentDidMount() {
    this.setState({ imageFile: this.props.modal.openParams.imageFile })
  }

  componentDidUpdate(prevProps) {
    if (!_.isEqual(this.props.modal.openParams, prevProps.modal.openParams)) {
      this.setState({ imageFile: this.props.modal.openParams.imageFile })
    }
  }

  showPortalImageGalleryModal = (params = {}) => {
    this.props.modalActions.showModal(PORTAL_IMAGE_STORE_MODAL, params)
  }

  showImageEditModal = (params = {}) => {
    this.props.modalActions.showModal(IMAGE_EDIT_MODAL, params)
  }

  handleSetProfileClick = () => {
    this.showImageEditModal({
      imageFile: this.state.imageFile,
      imageAspectRatio: 1,
      action: SET_PROFILE_IMAGE,
    })
  }
  handleUpdateProfileClick = () => {
    this.showImageEditModal({
      imageFile: this.state.imageFile,
      imageAspectRatio: 1,
      replaceImageID: this.props.portal.mainImageId,
      action: UPDATE_PROFILE_IMAGE,
    })
  }

  handleAddGalleryImageClick = () => {
    this.showImageEditModal({
      imageFile: this.state.imageFile,
      action: ADD_GALLERY_IMAGE,
      imageAspectRatio: 4 / 3,
    })
  }
  handleUpdateGalleryImageClick = () => {
    this.showPortalImageGalleryModal({
      imageFile: this.state.imageFile,
      storeImages: this.props.portal.galleryImages,
      action: UPDATE_GALLERY_IMAGE,
      imageAspectRatio: 4 / 3,
    })
  }
  handleAddLinkImageClick = () => {
    this.showImageEditModal({
      imageFile: this.state.imageFile,
      action: ADD_LINK_IMAGE,
      imageAspectRatio: 4 / 3,
    })
  }
  handleUpdateLinkImageClick = () => {
    this.showPortalImageGalleryModal({
      imageFile: this.state.imageFile,
      storeImages: this.props.portal.links,
      action: UPDATE_LINK_IMAGE,
      imageAspectRatio: 4 / 3,
    })
  }

  render() {
    const { portal } = this.props

    const isGalleryImageNotEmpty = !_.isEmpty(portal.galleryImages)
    const isLinkImageNotEmpty = !_.isEmpty(portal.links)

    return (
      <nav className="panel">
        <p className="panel-heading">ต้องการนำรูปไปทำอะไร ?</p>
        {portal.mainImageId ? (
          <a className="panel-block" onClick={this.handleUpdateProfileClick}>
            {/* <span className="panel-icon">
              <i className="fas fa-check" aria-hidden="true" />
            </span> */}
            <span className="tag is-info" style={{ width: 80, marginRight: 16 }}>
              <Trans>actions.replace.label</Trans>
            </span>{' '}
            <Trans>profileImage.label</Trans>
          </a>
        ) : (
          <a className="panel-block" onClick={this.handleSetProfileClick}>
            {/* <span className="panel-icon">
              <i className="fas fa-check" aria-hidden="true" />
            </span> */}
            <span className="tag is-primary" style={{ width: 80, marginRight: 16 }}>
              <Trans>actions.set.label</Trans>
            </span>{' '}
            <Trans>profileImage.label</Trans>
          </a>
        )}
        <a className="panel-block" onClick={this.handleAddGalleryImageClick}>
          {/* <span className="panel-icon">
            <i className="fas fa-check" aria-hidden="true" />
          </span> */}
          <span className="tag is-primary" style={{ width: 80, marginRight: 16 }}>
            <Trans>actions.add.label</Trans>
          </span>{' '}
          <Trans>galleryImage.label</Trans>
        </a>
        {isGalleryImageNotEmpty && (
          <a
            className="panel-block"
            onClick={this.handleUpdateGalleryImageClick}
          >
            {/* <span className="panel-icon">
              <i className="fas fa-check" aria-hidden="true" />
            </span> */}
            <span className="tag is-info" style={{ width: 80, marginRight: 16 }}>
              <Trans>actions.replace.label</Trans>
            </span>{' '}
            <Trans>galleryImage.label</Trans>
          </a>
        )}
        <a className="panel-block" onClick={this.handleAddLinkImageClick}>
          {/* <span className="panel-icon">
            <i className="fas fa-check" aria-hidden="true" />
          </span> */}
          <span className="tag is-primary" style={{ width: 80, marginRight: 16 }}>
            <Trans>actions.add.label</Trans>
          </span>{' '}
          <Trans>linkImage.label</Trans>
        </a>
        {isLinkImageNotEmpty && (
          <a className="panel-block" onClick={this.handleUpdateLinkImageClick}>
            {/* <span className="panel-icon">
              <i className="fas fa-check" aria-hidden="true" />
            </span> */}
            <span className="tag is-info" style={{ width: 80, marginRight: 16 }}>
              <Trans>actions.replace.label</Trans>
            </span>{' '}
            <Trans>linkImage.label</Trans>
          </a>
        )}
      </nav>
    )
  }
}
export default compose(
  withReduxModal,
  connect(({ portal }) => ({ portal })),
)(ImageActionModal)



// WEBPACK FOOTER //
// ./src/components/templates/image-management/ImageActionModal.js